import type { ListCreditNotesInput } from "@nexxt/contracts/procurement";
import { infiniteQueryOptions } from "@tanstack/react-query";
import { procurementClient } from "../client";
import { inboundQueries } from "../inbound/inbound.queries";

// Server state of the credit notes of the missing units (ADR-140), under the keys of the inbounds: the choice of the
// supplier creates one with a write on the inbound, and whatever reloads the inbounds reloads them too.

/** The filters of the list input (`listCreditNotesInput`) the screens set, as the URL holds them. */
export type CreditNoteFilters = Pick<ListCreditNotesInput, "status"> & {
  toReview?: true | undefined;
  toSend?: true | undefined;
  /** The file still owed after the last reminder and a cadence (B-41, ADR-245): Finance's queue. */
  remindersOver?: true | undefined;
  /** The supplier's side of the queues (ADR-170): for Tomorrow it takes nothing out. */
  asSupplier?: boolean | undefined;
  /** The sets of the app's queues "To do", as a JSON array (ADR-302). */
  anyOf?: string | undefined;
};

const PAGE_SIZE = 50;

const keys = {
  /** Prefix of every cached list of credit notes. */
  lists: [...inboundQueries.all, "credit-notes"] as const,
};

export const creditNoteQueries = {
  ...keys,

  list: (filters: CreditNoteFilters) =>
    infiniteQueryOptions({
      queryKey: [...keys.lists, filters],
      queryFn: ({ pageParam, signal }) =>
        procurementClient().listCreditNotes({ ...filters, page: pageParam, pageSize: PAGE_SIZE }, signal),
      initialPageParam: 1,
      getNextPageParam: (last) => (last.hasMore ? last.page + 1 : undefined),
    }),
};
